// extracted by mini-css-extract-plugin
module.exports = {"link":"Link--link--24di1","link__icon":"Link--link__icon--1yY1X"};